// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".red .codeColumn {\n  background-color: red;\n}\n\n.blue .codeColumn {\n  background-color: blue;\n}\n\n.yellow .codeColumn {\n  background-color: yellow;\n}\n\n.green .codeColumn {\n  background-color: limegreen;\n}\n\n.dqoi-search-bar {\n  margin-right: -26px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
